export default __webpack_public_path__ + "static/logo-0ace73fbcb46ff3ef746a693fc16512d.png";